import Confirm from './Confirm.vue';
import vuetify from '../../plugins/vuetify';

function Install(Vue, options) {
    const property = (options && options.property) || '$confirm'

    function createDialogCmp(options) {
        return new Promise(resolve => {
            const cmp = new Vue(Object.assign({}, Confirm, {
                vuetify,
                propsData: Object.assign({}, Vue.prototype.$confirm.options, options),
            }));
            cmp.$mount().$refs.dialog.isActive = true;

            cmp.$on('resolve', function (value) {
                resolve(value);
                cmp.$destroy();
            });
        })
    }

    function show(message, options = {}) {
        options.title = message;
        return createDialogCmp(options);
    }

    Vue.prototype[property] = show;
    Vue.prototype[property].options = options || {};
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Install);
}

export default Install;
